import { View } from "react-native"
import { router } from "expo-router"
import { Controller, useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"

import { Header, Text, TextInput, Button } from "@src/components"
import { Alert } from "@src/components/ui/confirm"
import { KeyboardAwareScrollView } from "@src/components/keyboard-aware-scroll-view"
import { createNotificationGroupInput } from "@white-labels/input"
import { trpc, sharedStyles } from "@src/utils"
import { ar } from "@src/i18n"

export default function NewNotificationGroup() {
  const utils = trpc.useUtils()
  const createGroup = trpc.notifications.groups.create.useMutation()

  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm({ resolver: zodResolver(createNotificationGroupInput), defaultValues: { name: "" }, mode: "onChange" })

  const onSubmit = handleSubmit((data) => {
    createGroup.mutate(data, {
      onSuccess: () => {
        void utils.notifications.groups.list.invalidate()
        if (router.canGoBack()) router.back()
      },
      onError: (e) => Alert.alert(ar.error, e.message),
    })
  })

  return (
    <>
      <Header title={ar.notificationNewGroup} />
      <KeyboardAwareScrollView className="w-full max-w-content mx-auto pt-2" contentContainerStyle={sharedStyles.contentContainer}>
        <Text className="font-bold mb-2">{ar.notificationGroupName}</Text>
        <Controller
          control={control}
          name="name"
          render={({ field: { onChange, value } }) => (
            <TextInput placeholder={ar.notificationGroupName} value={value} onChangeText={onChange} autoFocus />
          )}
        />
        <View className="mt-4">
          <Button onPress={onSubmit} loading={createGroup.isPending} disabled={!isValid || createGroup.isPending}>
            {ar.save}
          </Button>
        </View>
      </KeyboardAwareScrollView>
    </>
  )
}
